import { render, staticRenderFns } from "./dashboardFastCommandsGroupContextMenu.vue?vue&type=template&id=31b888ec"
import script from "./dashboardFastCommandsGroupContextMenu.vue?vue&type=script&lang=js"
export * from "./dashboardFastCommandsGroupContextMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports